const adresses = [
  // {
  //   name: "WHITE PUZZLE",
  //   adress: "L'Aubraie",
  //   city: "85610 Cugand",
  //   coordinates: "47.05090953364958, -1.2271889116499066",
  // },
  {
    name: "33 AND CO",
    adress: "49 Grand Rue",
    city: "67000 Strasbourg",
    coordinates: "48.5821553, 7.7418898",
  },
  {
    name: "79 TOURS",
    adress: "10, rue Brisson",
    city: "79000 Niort",
    coordinates: "46.3258452, -0.4640602",
  },
  {
    name: "ABERDEEN RECORDS",
    adress: "3 Rue du Helder",
    city: "64200 Biarritz",
    coordinates: "43.4818045, -1.5589473",
  },
  // {
  //   name: "ADIPOCERE",
  //   adress: "50 place Ferdinand de Beost",
  //   city: "01540 Vonnas",
  //   coordinates: "46.21870040893555, 4.991994380950928",
  // },
  {
    name: "ALL ACCESS",
    adress: "3 rue Brochant",
    city: "75017 Paris",
    coordinates: "48.8881816, 2.3167865",
  },
  {
    name: "BABALUMA",
    adress: "72 b rue JP Timbaud",
    city: "75011 Paris",
    coordinates: "48.85341, 2.3488",
  },
  {
    name: "BAD SEEDS",
    adress: "17, rue Fautras",
    city: "29200 Bret",
    coordinates: "48.3903658, -4.4914263",
  },
  {
    name: "BALADES SONORES",
    adress: "8 rue Pierre Picard",
    city: "75018 Paris",
    coordinates: "48.8847592, 2.3463417",
  },
  {
    name: "BAR ITALIA RECORDS",
    adress: "9 av Père Lachaise",
    city: "75020 Paris",
    coordinates: "48.8640328, 2.3975608",
  },
  {
    name: "BARNEYS GROOVE",
    adress: "17 rue carnot",
    city: "27200 Vernon",
    coordinates: "49.0926727, 1.4862526",
  },
  {
    name: "BAROMETRE",
    adress: "12 rue Léonard de Vinci",
    city: "37000 Tours",
    coordinates: "47.3909258, 0.6830535",
  },
  {
    name: "BAZOOM",
    adress: "6, rue du Belzic",
    city: "56400 Auray",
    coordinates: "47.6662791, -2.984545",
  },
  {
    name: "BESIDES RECORDS",
    adress: "47 r d'Amiens",
    city: "59800 Lille",
    coordinates: "50.6333762, 3.0645677",
  },
  // {
  //   name: "BETTY JANE ROSE",
  //   adress: "20 RUE DOMINIQUE DE GOURGUES",
  //   city: "40000 Mont de Marsan",
  //   coordinates: "43.8927345, -0.5025915",
  // },
  // {
  //   name: "BIGOUT RECORDS",
  //   adress: "22 rue des Capucins",
  //   city: "69001 Lyon",
  //   coordinates: "45.769531, 4.8352348",
  // },
  {
    name: "BIG SPIN",
    adress: "6 rue aux Namps",
    city: "14000 Caen",
    coordinates: "49.1840631, -0.3664693",
  },
  {
    name: "BIG STAR RECORDS",
    adress: "8 rue des Balances",
    city: "62000 ARRAS",
    coordinates: "50.290026, 2.778153",
  },
  {
    name: "BLACK BLUE",
    adress: "1 rue de la Carbonnerie",
    city: "34000 Montpellier",
    coordinates: "43.6117481, 3.8782448",
  },
  {
    name: "BLIND SPOT",
    adress: "36 rue Poullain Duparc",
    city: "35000 Rennes",
    coordinates: "48.1086683, -1.6823345",
  },
  {
    name: "BOHEME RECORDS",
    adress: "221 RUE LEON GAMBETTA",
    city: "59000 LILLE",
    coordinates: "50.6287209, 3.0529706",
  },
  {
    name: "BOP DISKAK",
    adress: "16, rue Marengo",
    city: "64100 Bayonne",
    coordinates: "43.4908735, -1.4731072",
  },
  {
    name: "CD BD PASCAL SCOTET",
    adress: "5 place Mondain Chanlouineau",
    city: "49100 ANGERS",
    coordinates: "47.4714527, -0.5541456",
  },
  {
    name: "BORN BAD",
    adress: "11 rue Saint Sabin",
    city: "75011 Paris",
    coordinates: "48.8552113, 2.3718829",
  },
  {
    name: "VIBRATIONS",
    adress: "48 rue Fesch",
    city: "20000 Ajaccio",
    coordinates: "41.922116, 8.7383912",
  },
  {
    name: "COBRA",
    adress: "66 avenue Parmentier",
    city: "75011 Paris",
    coordinates: "48.8632492, 2.376289",
  },
  {
    name: "COSMO NOTES",
    adress: "16 Rue Emile Burgault",
    city: "56000 Vannes",
    coordinates: "47.6584473, -2.7588357",
  },
  {
    name: "COSMIC TRIP",
    adress: "43 rue de l’Observance",
    city: "83300 DRAGUIGNAN",
    coordinates: "43.538971, 6.466979",
  },
  {
    name: "CROCODISC",
    adress: "42 rue des Ecoles",
    city: "75005 Paris",
    coordinates: "48.8493542, 2.3461225",
  },
  {
    name: "DIALOGUES MUSIQUES",
    adress: "52, rue Jean Macé",
    city: "29200 brest",
    coordinates: "48.3878703, -4.4901211",
  },
  {
    name: "DISCOPHENIA",
    adress: "56 Grande Rue",
    city: "91260 Juvisy sur Orge",
    coordinates: "48.6901463, 2.3754579",
  },
  {
    name: "DIAPASON",
    adress: "20 rue Ludovic Trarieux",
    city: "16000 Angouleme",
    coordinates: "45.6492723, 0.1554528",
  },
  {
    name: "ENCRAGE",
    adress: "8, rue du Temple",
    city: "68300 Saint-Louis",
    coordinates: "47.5875238, 7.5647792",
  },
  {
    name: "EPONYME VINYL",
    adress: "3 rue Cornac",
    city: "33000 Bordeaux",
    coordinates: "44.8509887, -0.5721201",
  },
  {
    name: "FREE MUSIC / DEMA",
    adress: "74 rue croix d'or",
    city: "73000 CHAMBERY",
    coordinates: "45.5646169, 5.9232052",
  },
  {
    name: "FORUM DISQUES",
    adress: "5, rue Michel-Rondet",
    city: "42000 Saint-Etienne",
    coordinates: "45.4382418, 4.3867261",
  },
  // {
  //   name: "GALETTE RECORD",
  //   adress: "70 rue des Trois Freres Bartelemy",
  //   city: "13006 marseille",
  //   coordinates: "43.2935442, 5.3871627",
  // },
  {
    name: "GIBERT LYON",
    adress: "3, quai Gailleton",
    city: "69002 Lyon",
    coordinates: "45.7569418, 4.8361054",
  },
  {
    name: "GIBERT MONTPELLIER",
    adress: "3 Place des Martyrs de la Résistance",
    city: "34000 Montpellier",
    coordinates: "43.6106247, 3.8768472",
  },
  {
    name: "GIBERT TOULOUSE",
    adress: "3, rue du Taur",
    city: "31000 Toulouse",
    coordinates: "43.6050074, 1.4427496",
  },
  {
    name: "GIBERT VAULX EN VELIN",
    adress: "2, rue Jacquard",
    city: "69120 Vaulx-en-Velin",
    coordinates: "45.7637409, 4.9202775",
  },
  {
    name: "GIBERT PARIS",
    adress: "34, boulevard Saint-Michel",
    city: "75006 Paris",
    coordinates: "48.8499096, 2.3421955",
  },
  {
    name: "GROUND ZERO",
    adress: "114 rue du Fbg Poissonnière",
    city: "75010 Paris",
    coordinates: "48.8793125, 2.3494693",
  },
  {
    name: "GROUND ZERO Montpellier",
    adress: "6 rue Sainte-Anne",
    city: "34000 Montpellier",
    coordinates: "43.6100043, 3.8742125",
  },
  {
    name: "HANDS AND ARMS",
    adress: "72 rue Corzatier",
    city: "75012 Paris",
    coordinates: "48.8500076, 2.3793567",
  },
  // {
  //   name: "HARK RECORDS",
  //   adress: "76 Rue Léon Frot",
  //   city: "75011 Paris",
  //   coordinates: "48.8573736, 2.3850153",
  // },
  {
    name: "HIT IMPORT",
    adress: "11, rue de Lépante",
    city: "06000 Nice",
    coordinates: "43.7039967, 7.2699825",
  },
  {
    name: "IT'S ONLY",
    adress: "3, rue Jean Jaurès",
    city: "35000 Rennes",
    coordinates: "48.1105525, -1.6779065",
  },
  {
    name: "VIDEO SELF JE CONSOLE",
    adress: "7 rue des généraux Crémer",
    city: "57200 Sarreguemines",
    coordinates: "49.109816, 7.066903",
  },
  {
    name: "JET RECORDS BIARRITZ",
    adress: "12 av Foch",
    city: "64200 Biarritz",
    coordinates: "43.4808859, -1.5589536",
  },
  {
    name: "JET RECORDS PAU",
    adress: "18, Rue des Cordeliers",
    city: "64000 Pau",
    coordinates: "43.2968714, -0.3715301",
  },
  // {
  //   name: "LA CELLULE REC",
  //   adress: "37 rue Paul Lendrin",
  //   city: "83000 Toulon",
  //   coordinates: "43.1228726, 5.9345776",
  // },
  {
    name: "LA DEMOTHEQUE",
    adress: "8, avenue Daumesnil",
    city: "24000 Périgueux",
    coordinates: "45.1837465, 0.7239261",
  },
  {
    name: "LA DISQUERIE",
    adress: "54 RUE FRANCHE",
    city: "71000 MACON",
    coordinates: "46.306029, 4.8352375",
  },
  {
    name: "FACE CACHEE",
    adress: "6 rue du Lancieu",
    city: "57000 Metz",
    coordinates: "49.1163022, 6.1755562",
  },
  {
    name: "MALLE A DISQUE",
    adress: "1 rue du Marché Lanselles",
    city: "80000 Amiens",
    coordinates: "49.8954942, 2.2975279",
  },
  {
    name: "PLAQUE TOURNANTE",
    adress: "8 rue Baron Quinard",
    city: "08000 Charleville-Mézières",
    coordinates: "49.7747639, 4.7208779",
  },
  {
    name: "LA TROCCASE",
    adress: "13 pass Théâtre",
    city: "68100 Mulhouse",
    coordinates: "47.7466028, 7.3402048",
  },
  // {
  //   name: "LE BRUIT QUI TOURNE",
  //   adress: "99 Rue Grande",
  //   city: "36000 Châteauroux",
  //   coordinates: "46.8126147, 1.6923085",
  // },
  {
    name: "LE DISCOBOLE",
    adress: "7, rue de la Porte Neuve",
    city: "68000 Colmar",
    coordinates: "48.0761906, 7.355295",
  },
  {
    name: "LE DISC'AIR DU BASSIN",
    adress: "37 cours de Verdun",
    city: "33470 Gujan-Mestras",
    coordinates: "44.636156, -1.076264",
  },
  {
    name: "LE GRAND CERCLE",
    adress: "1, rue du Bas Noyer",
    city: "95610 Éragny",
    coordinates: "49.031773, 2.1016",
  },
  {
    name: "LE LABORATOIRE",
    adress: "9 place de la Bourse",
    city: "31000 Toulouse",
    coordinates: "43.60046, 1.442462",
  },
  {
    name: "MANGE DISQUE grenoble",
    adress: "2 rue Genissieu",
    city: "38000 Grenoble",
    coordinates: "45.1863933, 5.7230638",
  },
  {
    name: "MICROSILLON",
    adress: "6 RUE NOTRE DAME",
    city: "61400 MORTAGNE AU PERCHE",
    coordinates: "48.5213303, 0.544916",
  },
  // {
  //   name: "Le Passage Culturel • Dixie Disques",
  //   adress: "81, place Travot",
  //   city: "49300 Cholet",
  //   coordinates: "47.0617063, -0.8805744",
  // },
  {
    name: "LE PASSEUR DE L’ISLE",
    adress: "7 Place de la liberté",
    city: "84800 L'Isle sur la Sorgue",
    coordinates: "43.91968536376953, 5.051734447479248",
  },
  // {
  //   name: "SILENCE DE LA RUE",
  //   adress: "39 rue Faidherbe",
  //   city: "75011 Paris",
  //   coordinates: "48.8534344, 2.3825128",
  // },
  {
    name: "LES ENFANTS DU ROC'H",
    adress: "17 bis Rue du Lac",
    city: "29690 Huelgoat",
    coordinates: "48.3640083, -3.7477055",
  },
  {
    name: "ACTES SUD",
    adress: "43 rue du Docteur Fanton",
    city: "13200 Arles",
    coordinates: "43.678489, 4.625065",
  },
  {
    name: "LIBRAIRIE CHEMINANT",
    adress: "19, rue Joseph le Brix",
    city: "56000 Vannes",
    coordinates: "47.6591114, -2.7591829",
  },
  {
    name: "LIBRAIRIE COSMOPOLITE",
    adress: "Galerie du Champ de Mars",
    city: "16000 Angoulême",
    coordinates: "45.6497689, 0.1624758",
  },
  {
    name: "Librairie Grand Forum",
    adress: "18, Place de la Révolution",
    city: "25000 Besançon",
    coordinates: "47.2396046, 6.0229052",
  },
  {
    name: "Librairie Maipiù",
    adress: "14, rue de l’Hôtel de Ville",
    city: "89700 Tonnerre",
    coordinates: "47.855988, 3.9737609",
  },
  {
    name: "Librairie Martin Delbert",
    adress: "85, boulevard de la République",
    city: "47000 Agen",
    coordinates: "44.2052091, 0.6197486",
  },
  {
    name: "Librairie Ocep",
    adress: "43, rue Saint-Nicolas",
    city: "50200 Coutances",
    coordinates: "49.0502143, -1.4439133",
  },
  {
    name: "LIBRAIRIE RAVY",
    adress: "10, rue de la Providence",
    city: "29000 Quimper",
    coordinates: "47.9970197, -4.1077012",
  },
  {
    name: "LOLLIPOP MUSIC STORE",
    adress: "2 bd Théodore Thurner",
    city: "13006 Marseille",
    coordinates: "43.2912736, 5.3831873",
  },
  {
    name: "LONG PLAY",
    adress: "56 rue Traversière",
    city: "75012 Paris",
    coordinates: "48.8497753, 2.3752998",
  },
  {
    name: "LP RECORDS",
    adress: "13 rue Saint-Gouéno",
    city: "22000 Saint-Brieuc",
    coordinates: "48.5143037, -2.7619565",
  },
  {
    name: "LUCKY RECORDS",
    adress: "66 rue de la Verrerie",
    city: "75004 Paris",
    coordinates: "48.8585774, 2.3514561",
  },
  {
    name: "LUCKY RECORDS lyon",
    adress: "6 Quai de la Pêcherie",
    city: "69001 Lyon",
    coordinates: "45.765855, 4.8310828",
  },
  {
    name: "MAJOR TOM",
    adress: "81 rue du Charolais",
    city: "75012 Paris",
    coordinates: "48.8430801, 2.3818193",
  },
  {
    name: "MANGE DISQUE bayonne",
    adress: "5, rue des Prébendes",
    city: "64100 Bayonne",
    coordinates: "43.49054718017578, -1.4784777164459229",
  },
  {
    name: "MELOMANE",
    adress: "2 quai Turenne",
    city: "44000 Nantes",
    coordinates: "47.2131528, -1.553753",
  },
  {
    name: "MOAR MUSIC SHOP",
    adress: "9 rue de la Paix",
    city: "44000 Nantes",
    coordinates: "47.21492004394531, -1.5545382499694824",
  },
  {
    name: "MUSIC AVENUE PARIS",
    adress: "10 rue Paul Bert",
    city: "75011 Paris",
    coordinates: "48.85172653198242, 2.384641408920288",
  },
  {
    name: "MOD DISC",
    adress: "132 av Gabriel Peri",
    city: "84300 Cavaillon",
    coordinates: "43.83462142944336, 5.040826320648193",
  },
  // {
  //   name: "MODULOR",
  //   adress: "28, rue du Surmelin",
  //   city: "75020 Paris",
  //   coordinates: "48.86911392211914, 2.4052255153656006",
  // },
  {
    name: "MTA VINYL SHOP",
    adress: "1, rue Pelleterie",
    city: "26000 Valence",
    coordinates: "44.93269348144531, 4.890599727630615",
  },
  {
    name: "NOIR & FEU records",
    adress: "67 av. Charles de Gaulle",
    city: "17300 Rochefort",
    coordinates: "45.9357492, -0.9629803",
  },
  {
    name: "PLEXUS RECORDS",
    adress: "172 Grand' Rue",
    city: "86000 Poitier",
    coordinates: "46.5826545, 0.345803",
  },
  {
    name: "POP HITS",
    adress: "6 rue des Lices",
    city: "49100 Angers",
    coordinates: "47.4690384, -0.5533377",
  },
  // {
  //   name: "POTEMKINE",
  //   adress: "30, rue Beaurepaire",
  //   city: "75010 Paris",
  //   coordinates: "48.8712439, 2.3643908",
  // },
  {
    name: "PUNK RECORDS",
    adress: "27 rue des maréchaux",
    city: "54000 Nancy",
    coordinates: "48.6941323, 6.1810711",
  },
  {
    name: "RECORDS DEALER",
    adress: "28 RUE DES LOMBARDS",
    city: "60200 COMPIEGNE",
    coordinates: "49.4161814, 2.8268663",
  },
  {
    name: "ROCK'n'ROLL VOLTAGE",
    adress: "30 rue de Rivoli",
    city: "75004 Paris",
    coordinates: "48.8561508, 2.3576074",
  },
  {
    name: "ROCK PARADISE",
    adress: "42 rue Duranton",
    city: "75015 Paris",
    coordinates: "48.8389892, 2.2880095",
  },
  {
    name: "ROLLING ROCK",
    adress: "3 rue Port",
    city: "63000 Clermont Ferrand",
    coordinates: "45.780101, 3.0865317",
  },
  {
    name: "SELECT RECORDS",
    adress: "97 rue de la Vicomté",
    city: "76000 Rouen",
    coordinates: "49.44186, 1.089128",
  },
  {
    name: "SOFA DISC",
    adress: "7 rue Algérie",
    city: "69001 Lyon",
    coordinates: "45.7671577, 4.8305109",
  },
  {
    name: "SOUFFLE CONTINU",
    adress: "22 r Gerbier",
    city: "75011 Paris",
    coordinates: "48.8589652, 2.386104",
  },
  // {
  //   name: "SPIRITS",
  //   adress: "9 Rue Augustin Bellard",
  //   city: "91590 La Ferté-Alais",
  //   coordinates: "48.483283, 2.347226",
  // },
  {
    name: "TANGERINE MUSIQUES",
    adress: "28 cours Julien",
    city: "13006 Marseille",
    coordinates: "43.2952285, 5.3825573",
  },
  {
    name: "THE MESSAGE",
    adress: "10 rue Juvenal des Ursins",
    city: "10000 Troyes",
    coordinates: "48.2955453, 4.0712709",
  },
  {
    name: "THE MIXTAPE",
    adress: "32 Rue des Trois Frères",
    city: "75018 Paris",
    coordinates: "48.8850449, 2.34043",
  },
  {
    name: "THE REV",
    adress: "6 quai de rigny",
    city: "19000 Tulle",
    coordinates: "45.264352, 1.766048",
  },
  {
    name: "TIKI VINYL STORE",
    adress: "19 rue René Leynaud",
    city: "69001 Lyon",
    coordinates: "45.7697872, 4.8331511",
  },
  // {
  //   name: "SON IMPUR",
  //   adress: "37, rue Beauvoisine",
  //   city: "76000 Rouen",
  //   coordinates: "49.4442254, 1.096306",
  // },
  {
    name: "TOTAL HEAVEN",
    adress: "6 r Candale",
    city: "33000 Bordeaux",
    coordinates: "44.8321287, -0.5720465",
  },
  {
    name: "URBAN MUSIC",
    adress: "Gal Gd Place / 8 place G De Gaulle",
    city: "59000 Lille",
    coordinates: "50.6365141, 3.0640532",
  },
  {
    name: "VACHEMENT BIEN",
    adress: "4, rue Terrasse",
    city: "63000 Clermont-Ferrand",
    coordinates: "45.7781913, 3.0848465",
  },
  // {
  //   name: "VINYLES AND VINTAGE",
  //   adress: "36 rue Ampère",
  //   city: "01960 Peronnas",
  //   coordinates: "46.1710394, 5.197382",
  // },
  {
    name: "VICIOUS CIRCLE",
    adress: "56 rue Gambetta",
    city: "31000 Toulouse",
    coordinates: "43.6036117, 1.4424225",
  },
  {
    name: "VINYL RUN",
    adress: "45 b rue du four a chaux",
    city: "97410 St Pierre La Réunion",
    coordinates: "-21.3393, 55.4781",
  },
  {
    name: "VINYLE ET HIFI VINTAGE",
    adress: "1, rue Gaspard Monge",
    city: "60200 Compiègne",
    coordinates: "49.3963913, 2.7882361",
  },
  // {
  //   name: "VINYLE ET HIFI VINTAGE",
  //   adress: "1, rue des Chaudronniers",
  //   city: "80000 Amiens",
  //   coordinates: "49.8955605, 2.2963732",
  // },
  // {
  //   name: "VINYLE ET HIFI VINTAGE",
  //   adress: "11, rue Ricard",
  //   city: "60000 Beauvais",
  //   coordinates: "49.4343918, 2.0824862",
  // },
  {
    name: "VINYLES 85",
    adress: "16 rue des Orfèvres",
    city: "85200 Fontenay le Comte",
    coordinates: "46.4675921, -0.8048659",
  },
  {
    name: "WATTS RECORDS",
    adress: "3 rue des Capucins",
    city: "69001 Lyon",
    coordinates: "45.7690921, 4.8326268",
  },
  {
    name: "ARCHI POP",
    adress: "18 rue des Allamandiers",
    city: "33800 Bordeaux",
    coordinates: "44.8340855, -0.5646624",
  },
  {
    name: "BC MUSIC",
    adress: "36 rue de l’Ancien Hôpital",
    city: "57100 Thionville",
    coordinates: "49.3589299, 6.1664865",
  },
  {
    name: "CIEL ROUGE",
    adress: "62 Rue Jean-Jacques Rousseau",
    city: "21000 Dijon",
    coordinates: "47.3245143, 5.0446981",
  },
  {
    name: "COLLECTORS BOUTIQUE",
    adress: "50 rue JJ Rousseau",
    city: "59370 Mons en Baroeul",
    coordinates: "50.63333, 3.11667",
  },
  {
    name: "LE COMPTOIR DU DISQUE",
    adress: "place Pétrarque",
    city: "34001 Montpellier",
    coordinates: "43.6107721, 3.8782479",
  },
  {
    name: "LE PASSAGE CULTUREL DIXIE DISQUES",
    adress: "81 place Travot",
    city: "49300 Cholet",
    coordinates: "47.0617063, -0.8805744",
  },
  {
    name: "LIBRAIRIE VOLCANS D'AUVERGNE",
    adress: "80 boulevard François Mitterrand",
    city: "63000 Clermont-Ferrand",
    coordinates: "45.7713145, 3.0844586",
  },
  {
    name: "OSO RECORDS",
    adress: "39 rue du Maréchal Joffre",
    city: "64000 Pau",
    coordinates: "43.2953127, -0.3728544",
  },
  {
    name: "UNIK MUSIC",
    adress: "104 rue Nationale",
    city: "72000 Le Mans",
    coordinates: "47.9980016, 0.2005346",
  },
  {
    name: "VINYL KAFE",
    adress: "6 avenue Maréchal Reille",
    city: "06600 Antibes",
    coordinates: "43.5785414, 7.1240226",
  },
];

export default adresses;
